import React, { Fragment } from "react";

import { Header, TwoColImgText } from "./../Elements";

export default () => (
  <Fragment>
    <Header title="Our Leadership" />

    <div id="content">
      <div className="col-md-10 mx-auto pt-2 pb-1">
        <TwoColImgText
          colSize1={8}
          colSize2={4}
          header={"PAUL HASTINGS – Chairman, Board of Directors"}
          content={[
            {
              class: "font-italic",
              text: "Paul has been a volunteer with the Youth Rally since first joining the team as a counselor in 1987. He has served the organization in many roles since, including current Chair of the Board of Directors and past President and CEO. A passionate patient advocate, Paul has been in the pharmaceutical industry since 1984. He is currently President and CEO of Nkarta Therapeutics and Chair of the Biotechnology Industry Association where he also chairs the Patient Advocacy Committee of the Board. Paul lives an active life traveling the globe. He was born with Crohn’s Disease and has had an ileostomy since 1979.",
            },
          ]}
          src="/assets/images/leaders/paul.png"
          alt="Paul Hastings"
        />

        <TwoColImgText
          colSize1={8}
          colSize2={4}
          header={
            "EMILY MALLAR – President & CEO; Committee Chair, Fundraising"
          }
          content={[
            {
              class: "font-italic",
              text: "Emily first joined the Youth Rally as a counselor in 2003 and has played a number of roles in program, recruitment, marketing, and fundraising since. She currently serves as the President and CEO of the organization and Chair of the Fundraising Committee. Emily was born with a rare form of fistulizing Crohn's Disease and has lived a vibrant life with an ileostomy since the age of 20. Emily lives in Ithaca, NY with her husband, son, and various 4-legged friends where she serves as a nursing administrator for the local health care system.",
            },
          ]}
          src="/assets/images/leaders/emily.png"
          alt="Emily Mallar"
        />

        <TwoColImgText
          colSize1={8}
          colSize2={4}
          header={
            "MARY BETH AKERS – Vice President, Registrar, Chief Financial Officer"
          }
          content={[
            {
              class: "font-italic",
              text: "Mary Beth was diagnosed with Ulcerative Colitis at the age of 14 and at 17 required ileostomy surgery. Almost 25 years later she was diagnosed with Crohn’s Disease. Mary Beth learned about the Youth Rally 5 years later after joining her local ostomy support group in St. Louis, MO. She has played a number of roles at the Youth Rally since her first year as a counselor in 1990 including registrar, travel coordinator, treasurer, and Chief Financial Officer. In her day job, Mary Beth is a middle school math teacher.",
            },
          ]}
          src="/assets/images/leaders/marybeth.png"
          alt="Mary Beth Akersr"
        />

        <TwoColImgText
          colSize1={8}
          colSize2={4}
          header={"ERIC ENG – Board of Directors; Committee Chair, Recruitment"}
          content={[
            {
              class: "font-italic",
              text: "Eric first joined the Youth Rally as a camper in 1995. In 2004 he joined the volunteer team as a counselor and has since played a number of additional roles in support of the program and administration teams. Eric currently serves as the Chair of the Recruitment Committee. Eric was born with VACTERL and Imperforate Anus and has lived with a continent diversion since the age of 13. Eric lives in St. Louis, MO where he serves as an IT Product Manager in the aerospace industry and remains active in his local ostomy support group.",
            },
          ]}
          src="/assets/images/leaders/eric.png"
          alt="Eric Eng"
        />

        <TwoColImgText
          colSize1={8}
          colSize2={4}
          header={"MICHAEL GERALD - Board of Directors"}
          content={[
            {
              class: "font-italic",
              text: "Michael first found his Youth Rally family in 1999 as a camper and later in 2006 as a counselor. For many years Michael has had the opportunity to utilize his unique skillset in social services as one of two Resource Counselors on site during rally. Michael currently resides in Providence, UT, where he serves on the Youth Rally Board of Directors while acting as Assistant Professor of Rehabilitation Counseling as a licensed clinical mental health counselor (LCMHC).",
            },
          ]}
          src="/assets/images/leaders/michael.png"
          alt="Michael Gerald"
        />

        <TwoColImgText
          colSize1={8}
          colSize2={4}
          header={"APRIL GIMLEN - Board of Directors"}
          content={[
            {
              class: "font-italic",
              text: "April lives in Alameda, CA and started volunteering at the Youth Rally in 1986 shortly after the birth of her daughter who was born with cloacal exstrophy requiring both a urostomy and colostomy at birth.  April has served as a counselor, program chairperson, fundraiser and speaker on behalf of the Youth Rally. She also was the founder of Parents of Ostomy Children and the South Bay Support Group for High Risk Infants.  These groups provided support for families dealing with long term health conditions of their children.  She previously worked in high school student activities and now spends her free time enjoying her grandchildren and travel.",
            },
          ]}
          src="/assets/images/leaders/april.png"
          alt="April Gimlen"
        />

        <TwoColImgText
          colSize1={8}
          colSize2={4}
          header={"JAY PACITTI - Board of Directors"}
          content={[
            {
              class: "font-italic",
              text: "Jay first joined Youth Rally as a counselor in 2016.  Diagnosed with Crohn's disease in 1999, Jay spent many years working to benefit the inflammatory bowel disease community, first as the founder and Executive Director of Get Your Guts in Gear - the Ride for Crohn's and Colitis, and later as the Executive Director of the United Ostomy Associations of America.  Jay is now a donor relations professional and enjoys sporting what can best be described as a unique orange hat while at Youth Rally, making it easy for campers assigned to his group to find him in a crowd.",
            },
          ]}
          src="/assets/images/leaders/jay.png"
          alt="Jay Pacitti"
        />

        <TwoColImgText
          colSize1={8}
          colSize2={4}
          header={"JACQUELYN DUNNE - Committee Chair, Program"}
          content={[
            {
              class: "font-italic",
              text: "Jackie first joined the Youth Rally as a counselor in 2003 after learning about it through the pediatric surgical team at the University of Maryland Medical Center while completing a project on pediatric urology for her undergraduate degree in psychology. Jackie was quick to join the program team - she enjoys the opportunity to shape the fun youth rally participants will have during the week. Jackie was born imperforate and is thankful to have found such a supportive community of folks with similar medical journeys. She and her family reside in Maryland where serves as a civilian for the federal US government. ",
            },
          ]}
          src="/assets/images/leaders/jackie.png"
          alt="Jackie"
        />

        <TwoColImgText
          colSize1={8}
          colSize2={4}
          header={"BRET CROMER - Board of Directors"}
          content={[
            {
              class: "font-italic",
              text: "Bret started volunteering at the Youth Rally in 2002 as a counselor and wishes he had known about the camp when he had ostomy surgery as a result of Crohn's Disease at age 16. Bret has served the Youth Rally in many ways including fundraising, coordinating travel, and facilitating group sessions. Bret lives in Aurora, IL. He enjoys traveling and snow/water skiing with his wife and son while traveling as much as possible. Bret currently works in the healthcare industry as Director of Customer Service for an organization that supports optimizing quality of life for those living with ostomies. ",
            },
          ]}
          src="/assets/images/leaders/bret.png"
          alt="Bret Comer"
        />
      </div>
    </div>
  </Fragment>
);
